import { useRef, useState } from 'react';
import logo from '../../assets/onze_solucoes_main.png';
import './Login.css';
import logoCreditBureau from '../../assets/onze_solucoes_login.png';
import getUser from '../../service/getUser/getUserService';
import postLogin from '../../service/postLogin/postLoginService';
import { UserCredentials } from '../../interface/UserCredentials';
import { GlobalSaveData } from "../../components/globalState/GlobalSaveData";
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import { Password } from 'primereact/password';
import { InputOtp } from 'primereact/inputotp';
import getRelatorioNotificacao from '../../service/getRelatorioNotificacao';
import { Messages } from 'primereact/messages';
import postAuthenticationDuploFator from '../../service/postAuthenticationDuploFator';
import { browserSupportsWebAuthn, startAuthentication } from '@simplewebauthn/browser';
import postAuthenticationPasskeyOptions from '../../service/postAuthenticationPasskeyOptions';
import postAuthenticationPasskeyFinalizar from '../../service/postAuthenticationPasskeyFinalizar';


import useMobile from '../../hooks/useMobile';
import './LoginMobile.css';

export default function Page() {
  const isMobile = useMobile();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [capsLockOn, setCapsLockOn] = useState(false);
  const [loginFocused, setLoginFocused] = useState(false);
  const [duploFatorRequired, setDuploFatorRequired] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [validando, setValidando] = useState(false);
  const [autenticandoPasskey, setAutenticandoPasskey] = useState(false);
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const suportaPasskey = browserSupportsWebAuthn();

  const showError = (detail: string) => {
    msgs.current?.clear();
    msgs.current?.show([
      { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail, closable: false }
    ]);
  };

  // fluxo executado após receber o token de autenticação
  const handleAuthenticated = (token?: string) => {
    GlobalSaveData("token", token)
    setTimeout(() => {
      getRelatorioNotificacao().then((data) => {
        GlobalSaveData("relatorios", data);
      });
    }, 100);

    setTimeout(() => {
      getUser().then((user) => {
        GlobalSaveData("user", user);
        setTimeout(() => { window.location.href = (user.urlRedirect && user.urlRedirect !== 'null' ? user.urlRedirect : '/creditbureau/home') }, 100);
      }).catch((error) => {
        showError('Login ou Senha inválidos');
      })
    }, 100);
  };

  const submit = () => {
    const userCredential: UserCredentials = { login: login, password: password };

    setTimeout(() => {
      postLogin(userCredential)
        .then((data) => {
          if (data?.duploFator) {
            setDuploFatorRequired(true);
            return;
          }
          handleAuthenticated(data?.token);
        })
        .catch((error) => {
          showError('Login ou Senha inválidos');
        })
    }, 1000);
  }

  const submitDuploFator = () => {
    setValidando(true);
    postAuthenticationDuploFator({ login, password, codigo })
      .then((data) => {
        handleAuthenticated(data?.token);
      })
      .catch((error) => {
        setValidando(false);
        showError('Código de verificação inválido');
      })
  };

  const loginComPasskey = async () => {
    setAutenticandoPasskey(true);
    try {
      const { sessionId, options } = await postAuthenticationPasskeyOptions();
      const credential = await startAuthentication({ optionsJSON: options });
      const data = await postAuthenticationPasskeyFinalizar(sessionId, credential);
      handleAuthenticated(data?.token);
    } catch (error: any) {
      if (error?.name !== 'NotAllowedError') {
        showError('Não foi possível autenticar com a chave de acesso');
      }
    } finally {
      setAutenticandoPasskey(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      submit();
    }
  };
  return (
    <>
      <div className={`main ${isMobile ? 'mobile-mode' : ''}`}>
        <div>
          <div className='logo_login'>
            <img src={logoCreditBureau} alt="logo" className='imageLogo' style={{"visibility": "hidden"}} />
          </div>
          <div className='card-login card'>
            <img src={logo} alt="logo" className='imageLogo' />
            <div className="login_form">
              <Messages ref={msgs} />
              <h2>Seja bem-vindo</h2>
              {!duploFatorRequired ? (
                <form className="input-container">
                  <div className="flex-auto">
                    <label htmlFor="login" className="font-bold block mb-2 required">{t('login')} </label>
                    <InputText
                      id="login"
                      value={login}
                      onChange={(e) => setLogin(e.target.value.toLowerCase().replace(/\s/g, ''))}
                      onFocus={() => setLoginFocused(true)}
                      onBlur={() => setLoginFocused(false)}
                      onKeyDown={(e) => {
                        setCapsLockOn(e.getModifierState('CapsLock'));
                        handleKeyDown(e);
                      }}
                      onKeyUp={(e) => setCapsLockOn(e.getModifierState('CapsLock'))}
                      style={isMobile ? { width: '100%' } : { width: '20rem' }}
                      required
                    />
                    {capsLockOn && loginFocused && (
                      <small className="login-caps-warning">
                        ⚠️ Caps Lock ativado! O texto será convertido para minúsculas.
                      </small>
                    )}
                  </div>
                  <br></br>
                  <div className="flex-auto">
                    <label htmlFor="login" className="font-bold block mb-2 required">{t('senha')} </label>
                    <Password onChange={(e) => setPassword(e.target.value.replace(/\s/g, ''))} onKeyDown={handleKeyDown} style={isMobile ? { width: '100%' } : { width: '20rem' }} feedback={false} toggleMask />
                  </div>
                  <button type='button' onClick={submit} className="btn-secondary">
                    Entrar
                  </button>
                   {suportaPasskey && (
                    <button
                      type='button'
                      onClick={loginComPasskey}
                      className="btn-secondary"
                      disabled={autenticandoPasskey}
                      style={{ marginTop: '0.75rem' }}
                    >
                      {autenticandoPasskey ? 'Autenticando...' : t('entrarComChaveAcesso')}
                    </button>
                  )}
                  <a href="/creditbureau/recuperacao" className="recovery">Esqueci minha senha</a>
                  <a href={require('../../assets/privacidade.pdf')} target="_blank" rel="noreferrer" className="privacity">Política de Privacidade</a>
                </form>
              ) : (
                <form className="input-container" onSubmit={(e) => e.preventDefault()}>
                  <div className="flex-auto" style={{ textAlign: 'center' }}>
                    <label className="font-bold block mb-2 required">
                      {t('duploFatorInstrucaoCodigo')}
                    </label>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <InputOtp
                        value={codigo}
                        onChange={(e) => setCodigo(String(e.value ?? ""))}
                        length={6}
                        integerOnly
                      />
                    </div>
                  </div>

                  <button
                    type='button'
                    onClick={submitDuploFator}
                    className="btn-secondary"
                    disabled={codigo.length < 6 || validando}
                  >
                    {validando ? 'Validando...' : 'Validar'}
                  </button>
                  <a
                    href="#voltar"
                    className="recovery"
                    onClick={(e) => {
                      e.preventDefault();
                      setDuploFatorRequired(false);
                      setCodigo("");
                    }}
                  >
                    Voltar
                  </a>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}
